import { ListResponse, ObjectResponse } from '@/src/types/common';
import { plainToInstance } from 'class-transformer';
import { CreditHistoryDto } from '@/src/models/CreditHistoryDto';
import {
  GetCreditHistoriesRequestParams,
  GetCreditHistoryByIdRequestParams,
  PostCreditHistoriesRequestBody,
} from '@/src/apis/rest/creditHistory.dtos';
import request from '@/src/apis/axios';
import { AdminCreditHistoryStatsDto } from '@/src/models/AdminCreditHistoryStatsDto';

const URL = {
  creditHistory: '/admin/credit-histories',
  creditHistoryDetail: '/admin/credit-histories/{id}',
  creditHistoryType: '/credits/credit-histories-types',
  creditHistoryExcel: '/admin/credit-histories/excel/export',
  creditDashboard: '/admin/credit-histories/stats/stats',
  creditHistorySubDescriptions:
    '/admin/credit-histories/distinct/sub-descriptions',
};

export const postCreditHistoriesAPI = async (
  requestBody: PostCreditHistoriesRequestBody,
) => {
  const { data } = await request<ObjectResponse<CreditHistoryDto>>({
    method: 'post',
    url: URL.creditHistory,
    requestBody,
  });

  return plainToInstance(CreditHistoryDto, data.row);
};
// 크레딧 리스트 조회
export const getCreditAPI = async (
  requestParams: Partial<GetCreditHistoriesRequestParams>,
) => {
  const { page = 1, pageSize = 10, ...rest } = requestParams;

  const { data } = await request<ListResponse<CreditHistoryDto>>({
    method: 'get',
    url: URL.creditHistory,
    queryParams: { ...rest, page, pageSize },
  });

  const rows = plainToInstance(CreditHistoryDto, data.rows);

  return { rows, count: data.count };
};
// 크레딧 상세 조회
export const getCreditByIdAPI = async ({
  id,
}: GetCreditHistoryByIdRequestParams) => {
  const { data } = await request<ObjectResponse<CreditHistoryDto>>({
    method: 'get',
    url: URL.creditHistoryDetail.replace('{id}', String(id)),
  });

  return plainToInstance(CreditHistoryDto, data.row);
};
// 크레딧 타입 조회
export const getCreditTypesAPI = async () => {
  const { data } = await request<ObjectResponse<Record<string, string>>>({
    method: 'get',
    url: URL.creditHistoryType,
  });

  return data.row;
};
// 크레딧 히스토리 엑셀 다운로드
export const getCreditExcelAPI = async (
  password: string,
  requestParams: Partial<GetCreditHistoriesRequestParams>,
) => {
  const { data } = await request<Blob>({
    method: 'get',
    url: URL.creditHistoryExcel,
    queryParams: { ...requestParams, password },
    config: { responseType: 'blob' },
  });

  return data;
};
// 크레딧 대시보드
export const getCreditDashboardAPI = async () => {
  const { data } = await request<ObjectResponse<AdminCreditHistoryStatsDto>>({
    method: 'get',
    url: URL.creditDashboard,
  });

  return data.row;
};
// 크레딧 하위 카테고리 목록 조회
export const getCreditSubDescriptionAPI = async () => {
  const { data } = await request<ListResponse<{ subDescription: string }>>({
    method: 'get',
    url: URL.creditHistorySubDescriptions,
  });

  const rows = plainToInstance(CreditHistoryDto, data.rows);

  return { rows, count: data.count };
};
